/** Special compatibility tokens selectable alongside specific vehicle values. */
export const PART_COMPATIBILITY_SPECIAL_VALUES = ['Universal', 'N/A'];
export const PARTS_COLLECTION = 'parts';
export const PART_REQUEST_STATUSES = [
    'requested',
    'ordered',
    'fulfilled',
    'cancelled',
];
export const PART_REQUESTS_COLLECTION = 'part_requests';
export const PART_FAVORITES_COLLECTION = 'part_favorites';
/** Phase-1 step-van chassis. Other models are not advertised as supported. */
export const STEP_VAN_MODELS = ['F59', 'MT45', 'MT55'];
export const STEP_VAN_COMPATIBILITY = {
    models: Array.from(STEP_VAN_MODELS),
};
export const isStepVanModel = (model) => STEP_VAN_MODELS.includes(model);
/** True when a part is Universal, N/A, unset, or tagged for a step-van model. */
export const partFitsStepVanPhase = (compatibility) => {
    const models = compatibility?.model;
    if (!models?.length)
        return true;
    if (models.includes('Universal') || models.includes('N/A'))
        return true;
    return models.some((model) => isStepVanModel(model));
};
export const inferStepVanModelsFromText = (...chunks) => {
    const found = new Set();
    for (const chunk of chunks) {
        if (!chunk)
            continue;
        const matches = chunk.match(/\b(F-?59|MT-?45|MT-?55)\b/gi) ?? [];
        for (const match of matches) {
            const raw = match.replace(/-/g, '').toUpperCase();
            if (raw === 'F59' || raw === 'MT45' || raw === 'MT55')
                found.add(raw);
        }
    }
    return Array.from(found);
};
export const PARTS_SCRAPE_RUNS_COLLECTION = 'parts_scrape_runs';
export const PART_TRAINING_LABELS_COLLECTION = 'part_training_labels';
export const PART_TRAINING_LABEL_TYPES = [
    'mirror',
    'bumper',
    'door',
    'fender',
    'hood',
    'grille',
    'headlight',
    'taillight',
    'wheel',
    'windshield',
    'step',
    'other',
];
